<template>
	<div class="MAM_queryList">
		<div style="margin-bottom: 20px;">
		    <el-button size="small" icon="el-icon-back" @click="$router.back()">返 回</el-button>
		</div>
		<!-- 表单搜索部分 -->
		<el-card class="box-card" shadow="hover">
			<el-form :inline="true" :model="queryForm" class="demo-form-inline">
				<el-form-item>
					<el-input size clearable v-model="queryForm.sn" placeholder="SN号"></el-input>
				</el-form-item>
				<el-form-item>
					<el-date-picker type="date" placeholder="入库开始时间" v-model="queryForm.start_time"
						value-format="yyyy-MM-dd" style="width: 150px;"></el-date-picker>
					-
					<el-date-picker type="date" placeholder="入库结束时间" v-model="queryForm.end_time"
						value-format="yyyy-MM-dd" style="width: 150px;"></el-date-picker>
				</el-form-item>
				<el-form-item>
					<el-select size v-model="queryForm.is_active" clearable placeholder="激活状态">
						<el-option label="已激活" value="1"></el-option>
						<el-option label="未激活" value="0"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-select size v-model="queryForm.is_bind" clearable placeholder="绑定状态">
						<el-option label="已绑定" value="1"></el-option>
						<el-option label="未绑定" value="0"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-select size v-model="queryForm.is_exchange" clearable placeholder="兑换状态">
						<el-option label="已兑换" value="1"></el-option>
						<el-option label="未兑换" value="0"></el-option>
					</el-select>
				</el-form-item>

				<el-form-item>
					<el-button size="medium" type="primary" icon="el-icon-search" style="font-size: 12px;"
						@click="onSearch(queryForm)">查询</el-button>
				</el-form-item>
			</el-form>
		</el-card>
		<!-- 表格部分 -->
		<el-card class="box-card" style="margin-top: 20px;" shadow="hover">
			<div style="margin-bottom:20px">
				<span>共计拿货：{{stockTable.all_num}} 台</span>
				<span style="margin:0px 50px">已激活：{{stockTable.active_num}} 台</span>
				<span>已兑换：{{stockTable.exchange_num}} 台</span>

				<el-button style="font-size: 12px;margin-left:20px" size="small" type="primary" icon="el-icon-download"
					:loading="downLoading" @click="handleDownLoad(queryForm)">导出数据</el-button>
			</div>
			<el-table :data="stockTable.list" size="mini" border style="width: 100%" v-loading="loading">
				<el-table-column header-align="center" align="center" prop="sn" label="SN"></el-table-column>
				<el-table-column header-align="center" align="center" prop="term_type" label="型号"></el-table-column>
				<el-table-column header-align="center" align="center" prop="brand_name" label="政策"></el-table-column>
				<el-table-column header-align="center" align="center" prop="merchant_number" label="商户编号">
					<template slot-scope="scope">
						<span>
							{{scope.row.merchant_number?scope.row.merchant_number:'-'}}
						</span>
					</template>
				</el-table-column>
				<el-table-column header-align="center" align="center" prop="merchant_name" label="商户姓名">
					<template slot-scope="scope">
						<span>
							{{scope.row.merchant_name?scope.row.merchant_name:'-'}}
						</span>
					</template>
				</el-table-column>
				<el-table-column header-align="center" align="center" prop="is_bind" label="绑定状态">
					<template slot-scope="scope">
						<span>
							{{scope.row.is_bind == 0?'未绑定':'已绑定'}}
						</span>
					</template>
				</el-table-column>
				<el-table-column header-align="center" align="center" prop="bind_time" label="绑定时间"></el-table-column>
				<el-table-column header-align="center" align="center" prop="is_active" label="激活状态">
					<template slot-scope="scope">
						<span>
							{{scope.row.is_active == 0?'未激活':'已激活'}}
						</span>
					</template>
				</el-table-column>
				<el-table-column header-align="center" align="center" prop="active_time" label="激活时间"></el-table-column>
				<el-table-column header-align="center" align="center" prop="is_exchange" label="兑换状态">
					<template slot-scope="scope">
						<span>
							{{scope.row.is_exchange == 0?'未兑换':'已兑换'}}
						</span>
					</template>
				</el-table-column>
				<el-table-column header-align="center" align="center" prop="exchange_time"
					label="兑换时间"></el-table-column>
				<el-table-column header-align="center" align="center" prop="create_time" label="入库时间"></el-table-column>
				<el-table-column header-align="center" align="center" prop="receive_time"
					label="划拨时间"></el-table-column>
			</el-table>
			<!-- 分页部分 -->
			<paginations :currentPage="page.currentPage" :pageSize="page.pageSize" :total="page.total"
				@watchCurrent="getCurrent" @watchPageSize="getPageSize"></paginations>
		</el-card>

	</div>
</template>

<script>
	import paginations from '../../../components/pagination/paginations';
	export default {
		name: "terminalPickup",
		data() {
			return {
				queryForm: {
					user_id: this.$route.query.user_id,
					sn:'',
					start_time:'',
					end_time:'',
					is_active:'',
					is_exchange:'',
					is_bind:''
				},
				stockTable: { //列表
					all_num: 0,
					active_num: 0,
					exchange_num: 0,
					list: [],
				},
				page: {
					currentPage: 1, //当前页码
					pageSize: 10, //条数
					total: 0 //总数
				},
				loading: true,
				downLoading: false, //导出loading
			}
		},
		mounted() {
			this.handleDefaultTime();
			this.getData({
				page: this.page.currentPage,
				limit: this.page.pageSize,
				user_id: this.$route.query.user_id,
				start_time:this.queryForm.start_time,
				end_time:this.queryForm.end_time
			})
		},
		components: {
			paginations,
		},
		methods: {
			handleDefaultTime() { //默认获取三十天
			    let date =this.$moment().endOf('day').format('x');
			    this.queryForm.end_time = this.$moment(Number(date) - 3600 * 1000 * 24 -1).format("YYYY-MM-DD");
			    this.queryForm.start_time = this.$moment(Number(date) - 3600 * 1000 * 24 * 31 +1).format("YYYY-MM-DD");
			},
			handleDownLoad(params) { //导出
				let reqData = {
					type: 10,
					value: JSON.stringify(params)
				};

				this.downLoading = true;
				this.$api.post('export/add', reqData, res => {
					if (res.code == 0) {
						this.$message.success(res.msg);
						this.downLoading = false;
					} else {
						this.$message.error(res.msg);
						this.downLoading = false;
					}

				})
			},
			onSearch(queryForm) {
				this.page.currentPage = 1;
				queryForm.page = this.page.currentPage;
				queryForm.limit = this.page.pageSize;
				// 表单提交
				this.getData(queryForm);
			},
			//分页
			getCurrent(page) {
				// 获取当前页修改的值
				this.page.currentPage = page;
				this.loading = true;
				this.queryForm.page = page;
				this.queryForm.limit = this.page.pageSize;
				this.getData(this.queryForm);
			},
			getPageSize(limit) {
				this.page.currentPage = 1;
				// 获取条数发生改变的值
				this.page.pageSize = limit;
				this.loading = true;
				this.queryForm.page = this.page.currentPage;
				this.queryForm.limit = limit;
				this.getData(this.queryForm);
			},
			getData(params) {
				this.$api.post("user_team/getTerminalList", params, res => {
					if (res.code == 0) {
						let data = res.data;
						this.page.total = data.all_num; //总数
						this.stockTable.list = res.data.list;

						this.stockTable.all_num = res.data.all_num;
						this.stockTable.active_num = res.data.active_num;
						this.stockTable.exchange_num = res.data.exchange_num;
					} else {
						this.$message.error(res.msg);
					}
					// //渲染结束后取消加载
					this.loading = false;
				})
			}
		}
	};
</script>

<style lang="scss" scope>
	.MAM_queryList {
		.el-input__inner {
			font-size: 12px;
		}

		.el-form-item {
			margin-bottom: 5px;
		}
	}
</style>